import { useQuery } from '@hooks/reactQuery';

import { getAlarmsFlexidas } from '@api/alarmManagement';

import { extractQueryParams } from '@utils/common';

import { IAlarmsFlexidas } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EVendorsValues } from '@enums/common';

import { ALARMS_FLEXIDAS } from '@constants/queryKeys';

interface IUseQueryAlarmsFlexidasReturn {
	isLoading: boolean;
	data: IAlarmsFlexidas[];
	countOfRecords: number;
}

export const useQueryAlarmsListFlexidas = (params: IAlarmByVendor): IUseQueryAlarmsFlexidasReturn => {
	const {
		data,
		isInitialLoading: isLoadingAlarmsFlexidas,
	} = useQuery({
		queryKey: [ALARMS_FLEXIDAS, params],
		queryFn: extractQueryParams(getAlarmsFlexidas),
		enabled: [params.vendor === EVendorsValues.flexidas],
		refetchOnWindowFocus: false,
	});

	return {
		isLoading: isLoadingAlarmsFlexidas,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
